export const DETAIL_SCOPE = Symbol('provider detail scope');
export const getMediaDetailsScope = (resource) => resource[DETAIL_SCOPE];
// Transient readiness markers never enter ordinary editor resources or story JSON.
export const playableResource = (resource) =>
  Object.fromEntries(Object.entries(resource));
export const isCanceled = (error) =>
  error?.name === 'AbortError' ||
  error?.code === 'ERR_CANCELED' ||
  error?.__CANCEL__;
export const createAbortError = () =>
  Object.assign(new Error('Canceled'), { name: 'AbortError' });
// Gallery summaries and ScorePlay videos must pass through the detail resolver.
export const isProviderSummary = (resource) =>
  Boolean(resource?.galleryOnly) ||
  (resource?.type === 'video' &&
    /^media\/SCOREPLAY:/i.test(resource?.id || ''));
export const notifyDetailFailure = (showSnackbar, error) => {
  if (!isCanceled(error))
    showSnackbar({
      message: 'Could not load video. Try again.',
      dismissable: true,
    });
  return null;
};
